import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';

export const AboutPreview = () => {
  const features = [
    'Višegodišnje iskustvo',
    'Sertifikovani materijali',
    'Profesionalna montaža',
    'Garancija na radove'
  ];

  return (
    <Section>
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-secondary font-bold uppercase tracking-widest mb-2 text-sm">O Nama</h2>
        <h3 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900">
          Tradicija Kvaliteta i <br />
          <span className="text-primary">Moderne Tehnologije</span>
        </h3>
        <p className="text-gray-600 mb-8 leading-relaxed text-lg">
          Stolarija Leskovac je lider u proizvodnji i ugradnji ALU i PVC stolarije u regionu. 
          Naš tim stručnjaka posvećen je pružanju vrhunskih rešenja koja kombinuju estetiku, 
          funkcionalnost i energetsku efikasnost.
        </p>
        
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8 max-w-2xl mx-auto">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center gap-3 text-gray-700 font-medium justify-center sm:justify-start">
              <CheckCircle2 className="text-secondary shrink-0" size={20} />
              {feature}
            </li>
          ))}
        </ul>

        <Link to="/o-nama">
          <Button variant="outline" className="group">
            Saznajte Više 
            <ArrowRight size={18} className="ml-2 transition-transform group-hover:translate-x-1" />
          </Button>
        </Link>
      </div>
    </Section>
  );
};
